(ns dashboard.components.search.view
  (:require [dashboard.components.search.events :as events]
            [dashboard.components.search.search-box :as search-box]
            [dashboard.services.document-viewer :as document-viewer]
            [re-frame.core :as rf]
            [react]))

(defn quick-search
  "This function is a wrapper to allow us to re-use the search bar
   in other contexts, while providing the dashboard.services.documents
   dependancy, allowing search-box to be reused agnostic of the
   dashboard.services.documents namespace."
  [do-not-close-on-click]
  [:<>
   [:div
    {:style {:position "absolute"
             :top 0
             :left 0
             :z-index 1001
             :width "100vw"
             :height "100vh"
             :background-color "#00000022"}
     :on-click #(rf/dispatch [::events/set-search-visible false])}]
   [:f> search-box/search-panel
    (fn [& args]
      (rf/dispatch (into [::document-viewer/fetch-file-preview-url]
                         args)))
    do-not-close-on-click
    nil]])
